// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"353":"1012ebce","547":"8230ae64"}[chunkId] + ".chunk.css";
};